import { db } from '@/main';
import { firestoreAction } from 'vuexfire';

export default {
  namespaced: true,
  state: {
    // config db records
    records: [],
  },
  actions: {
    bindRecords: firestoreAction(({ bindFirestoreRef }, payload = {}) => {
      let ref = db.collection('config').doc('base');

      return bindFirestoreRef('records', ref);
    }),
  },
  getters: {
    records(state) {
      return state.records;
    },
  },
  mutations: {},
};
